import React from "react"
import { RoteirizacaoContextProvider } from "./context/RoteirizacaoContextProvider"
import { Roteirizacao } from "./Roteirizacao"

export function Index() {
    return (
        <RoteirizacaoContextProvider>
            <Roteirizacao />
        </RoteirizacaoContextProvider>
    )
}
